<!--
 * @Author: 杨源
 * @Date: 2022-09-02 10:54:32
 * @LastEditors: 杨源
 * @LastEditTime: 2022-09-02 11:20:13
 * @FilePath: \integration_view\src\components\system\dict\DictDataShow.vue
 * @Description:
-->
<template>
  <div class="dict">
    <span>{{ showText }}</span>
  </div>
</template>

<script>
import { findByDictCode } from "@/api/system/dictData";
export default {
  name: "DictDataShow",
  props: {
    code: {
      type: String,
      require: true,
    },
    value: {},
  },
  data() {
    return {
      dataList: [],
      showText: "",
    };
  },
  computed: {},
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.showText = this.dataList.find((item) => item.code === this.value)?.label;
        }
      },
    },
  },
  async created() {
    findByDictCode({
      dictCode: this.code,
    })
      .cache()
      .then((data) => {
        // console.log(data)
        this.dataList = data;
        this.showText = data.find((item) => item.code === this.value)?.label;
      });
  },
};
</script>

<style lang='scss' scoped>
.el-input.is-disabled /deep/ .el-input__inner {
  color: black;
  background-color: white !important;
}
</style>
